import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { LoadingCircle } from '../../../../src/components/common/loading';
import { NavigationList, NavigationListItem } from '@dbk/ui-list';
import Button from '@dbk/ui-buttons';
import { Trash, Edit } from '@dbk/ui-icons';
import { FormGroup, Label } from '@dbk/ui-forms';
import VascoModal from '../../auth/vasco/vasco-modal';
import { Settings } from '@dbk/ui-icons';
import { isEmpty, isEqual } from 'lodash';
import FilterModal from './filter-modal';
import DeleteContactModal from './delete-contact-modal';
import '../../../../src/assets/styles/hrmw-mcd.scss';
import BlurModal from '../../../../src/components/common/blur-modal';
import { ROUTES, PALETTE, MANAGE_CONTACT_DETAILS_CONSTANTS, VASCO_ERROR_MESSAGES, PAPERLESS_OPT_IN_STATUS } from '../../../constants';
import message from '@dbk/ui-forms/src/message/message';
import Toggle from '@dbk/ui-toggle';
 import Popover from '@dbk/ui-popover';
import { Info2 } from '@dbk/ui-icons';

class ManageContactDetails extends Component {
	constructor(props) {
		super(props);
		props.hrmw.getContactDetailsListData();
		this.props.hrmw.getBpData();
		this.state = ({
			showDeleterModal: false,
			showFilterModal: false,
			filterTitle: '',
			isEmailFilterSelected: false,
			isPhoneFilterSelected: false,
			isFaxFilterSelected: false,
			contactDetailsListData: [],
			deleteContactTitle: '',
			contactToBeDeleted: '',
			selectedContactId: '',
			personSelected: '',
			amendedContactDetail: '',
			isDataUPdated: false
		});
	}

	componentDidMount = () => {
		this.props.hrmw.setIsMCDPage(true);
	}

	componentWillUnmount = () => {
		this.props.hrmw.setIsMCDPage(false);
		this.props.hrmw.setIsAddContactDetailsFlow(false);
	}

	componentWillMount = async () => {
		await this.props.hrmw.getContactDetailsListData();
		this.setState({
			contactDetailsListData: this.props.hrmw.contactDetailsListData,
			contactDetailsPersonData: this.props.hrmw.contactDetailsPersonData
		});
	}

	componentWillUnmount() {
		this.props.hrmw.setfromPaperless(false); 
	}

	async componentWillReceiveProps(nextProps) {

		if(nextProps.hrmw.saveContactDetailsStatus) {
			this.saveContactDetailsOtp();
		}

		let newContactArray;
		if (isEmpty(nextProps.hrmw.latestContactDetails)) {
			this.setState({
				contactDetailsListData: nextProps.hrmw.contactDetailsListData
			})
			await nextProps.hrmw.setUpdatedContactDetails(nextProps.hrmw.contactDetailsListData);
			newContactArray = nextProps.hrmw.contactDetailsListData;
		} else {
			newContactArray = nextProps.hrmw.latestContactDetails;
		}

		// set Amend contact details 
		if (!isEmpty(nextProps.hrmw.amendContactDetail)) {
			if(nextProps.hrmw.amendContactDetail.amendDetails) {
				// get selected person details
				let personData = nextProps.hrmw.contactDetailsPersonData;
				personData = personData.filter((row) => row.personId === nextProps.hrmw.amendContactDetail.person.personId);
				personData = personData[0];

				// contact details after amendment
				const amendedContactDetail = nextProps.hrmw.amendContactDetail;

				// get type of contact details i.e phone, fax or email
				const selectedContactType = amendedContactDetail.fax ? MANAGE_CONTACT_DETAILS_CONSTANTS.FAX : (amendedContactDetail.emailId) ? MANAGE_CONTACT_DETAILS_CONSTANTS.EMAILID : MANAGE_CONTACT_DETAILS_CONSTANTS.PHONE_NO;

				if(nextProps.hrmw.amendContactDetail.isNewlyAdded) {
					// push updated changes to UI show var.
					newContactArray.forEach(function (row) {
						if (row.contactId === amendedContactDetail.contactId) {

							if(personData.name) {
								row.person.name = personData.name;
								row.person.firstName = '';
								row.person.middleName = '';
								row.person.lastName = '';
							} else {
								row.person.firstName = personData.firstName;
								row.person.middleName = personData.middleName;
								row.person.lastName = personData.lastName;
								row.person.name = '';
							}

							row.action = amendedContactDetail.action;
							row.person.personId = amendedContactDetail.person.personId;

							// adding emailId
							if(selectedContactType == MANAGE_CONTACT_DETAILS_CONSTANTS.EMAILID) {
								row[selectedContactType] = amendedContactDetail[selectedContactType];
							}
							
							// adding fax
							if(selectedContactType == MANAGE_CONTACT_DETAILS_CONSTANTS.FAX) {
								let faxObj = {
									phoneNo: amendedContactDetail.fax,
									countryCode: amendedContactDetail.countryCode
								};
								row.fax = faxObj;
							}

							// adding Phone No
							if(selectedContactType == MANAGE_CONTACT_DETAILS_CONSTANTS.PHONE_NO) {
								let phoneObj = {
									phoneNo: amendedContactDetail.phoneNo,
									countryCode: amendedContactDetail.countryCode,
									phoneType: amendedContactDetail.phoneType
								}
								row.phone = phoneObj;
							}
						}
					});
				} else {

					// actual contact details before updation
					let latestContactDetails = nextProps.hrmw.contactDetailsListData;
					let actualContactDetail = latestContactDetails.filter((row) => row.contactId == amendedContactDetail.contactId);
					actualContactDetail = actualContactDetail[0];

						// check for person value change
						const isSelectedPersonEqual = isEqual(amendedContactDetail.person.personId, actualContactDetail.person.personId);

						// check if there is any change in Phone no details
						if(selectedContactType == MANAGE_CONTACT_DETAILS_CONSTANTS.PHONE_NO) {
							const isPhoneCountryEqual = isEqual(Number(amendedContactDetail.countryCode), Number(actualContactDetail.phone.countryCode));
							const isPhoneTypeEqual = isEqual(amendedContactDetail.phoneType, actualContactDetail.phone.phoneType);
							const isPhonoNoEqual = isEqual(amendedContactDetail.phoneNo ? String(amendedContactDetail.phoneNo) : String(amendedContactDetail.phone.phoneNo), String(actualContactDetail.phone.phoneNo));

							if(isPhoneCountryEqual && isPhoneTypeEqual && isPhonoNoEqual && isSelectedPersonEqual) {
								amendedContactDetail.isUpdated = false;
							} else {
								amendedContactDetail.isUpdated = true;
							}
						}

						// check if there is any change in fax
						if(selectedContactType == MANAGE_CONTACT_DETAILS_CONSTANTS.FAX) {
							const isFaxCountryEqual = isEqual(Number(amendedContactDetail.countryCode), Number(actualContactDetail.fax.countryCode));
							const isFaxNoEqual = isEqual(amendedContactDetail.fax, actualContactDetail.fax.phoneNo);

							if( isFaxCountryEqual && isFaxNoEqual && isSelectedPersonEqual) {
								amendedContactDetail.isUpdated = false;
							} else {
								amendedContactDetail.isUpdated = true;
							}
						}

						// check if there is any change in email
						if(selectedContactType == MANAGE_CONTACT_DETAILS_CONSTANTS.EMAILID) {
							const isEmailValueEqual = isEqual(amendedContactDetail.emailId, actualContactDetail.emailId);

							if(isEmailValueEqual && isSelectedPersonEqual) {
								amendedContactDetail.isUpdated = false;
							} else {
								amendedContactDetail.isUpdated = true;
							}
						}


					// push updated changes to UI show var.
					newContactArray.forEach(function (row) {
						if (row.contactId === amendedContactDetail.contactId) {

							if(personData.name) {
								row.person.name = personData.name;
								row.person.firstName = '';
								row.person.middleName = '';
								row.person.lastName = '';
							} else {
								row.person.firstName = personData.firstName;
								row.person.middleName = personData.middleName;
								row.person.lastName = personData.lastName;
								row.person.name = '';
							}

							row.action = amendedContactDetail.action;
							row.isUpdated = amendedContactDetail.isUpdated;
							row.person.personId = amendedContactDetail.person.personId;
							if(selectedContactType == MANAGE_CONTACT_DETAILS_CONSTANTS.EMAILID) {
								row[selectedContactType] = amendedContactDetail[selectedContactType];
							}
							
							if(selectedContactType == MANAGE_CONTACT_DETAILS_CONSTANTS.PHONE_NO) {
								row.phone.countryCode = amendedContactDetail.countryCode ||amendedContactDetail.phone.countryCode;
								row.phone.phoneType = amendedContactDetail.phoneType
								row.phone.phoneNo = amendedContactDetail.phoneNo ||amendedContactDetail.phone.phoneNo;
							}

							if(selectedContactType == MANAGE_CONTACT_DETAILS_CONSTANTS.FAX) {
								row.fax.countryCode = amendedContactDetail.countryCode || amendedContactDetail.fax.countryCode;
								row.fax.phoneNo = amendedContactDetail.fax || amendedContactDetail.fax.phoneNo;
							}
						}
					});
				}
			}
			// updation done, making muster variable empty
			await this.props.hrmw.contactToBeAmend('');
		}

		// set deleted contact details
		if (!isEmpty(nextProps.hrmw.deletedContact)) {

			if(nextProps.hrmw.deletedContact.isNewlyAdded) {
				newContactArray = newContactArray.filter((row) => row.contactId != nextProps.hrmw.deletedContact.contactId);
			} else {
				newContactArray.forEach(function (row) {
					if(row.contactId === nextProps.hrmw.deletedContact.contactId) {
						row.isDeleted = true;
						row.isUpdated = false;
					}
				});
			}
			await this.props.setDeletedRow(nextProps.hrmw.deletedContact.isDeleted);
			//deletion done, making muster empty
			await this.props.hrmw.setDeletedContactList('');

		}

		// set toggled contact details
		if (!isEmpty(nextProps.hrmw.toggledContactDetail)) {

				newContactArray.forEach(function (row) {
					if (row.contactId === nextProps.hrmw.toggledContactDetail.contactId) {
						row.ealerts = row.ealerts === PAPERLESS_OPT_IN_STATUS.EALERT_YES ? PAPERLESS_OPT_IN_STATUS.EALERT_NO : PAPERLESS_OPT_IN_STATUS.EALERT_YES;
						row.isEalert = !row.isEalert;
					}
				});
			// toggle done, set muster variable as empty
			await this.props.hrmw.setToggledContactDetail('');

		}

		// set applied filters
		if(!isEmpty(nextProps.hrmw.appliedFilters)) {

			let isContactTypeSelected = true;

			// No filter selected
			if(!nextProps.hrmw.appliedFilters.isEmailFilterSelected && !nextProps.hrmw.appliedFilters.isFaxFilterSelected && 
				!nextProps.hrmw.appliedFilters.isPhoneFilterSelected) {

				isContactTypeSelected = false;

				if(!nextProps.hrmw.appliedFilters.personIdSelected){
					newContactArray.forEach(function (row) {
						row.isVisible = true;
					});
				}
			}

			// check combination of person and type of contact
			if(nextProps.hrmw.appliedFilters.personIdSelected && isContactTypeSelected)  {
				newContactArray.forEach(function (row) {
					row.isVisible = false;

					if(row.person.personId == nextProps.hrmw.appliedFilters.personIdSelected) {
						if(nextProps.hrmw.appliedFilters.isEmailFilterSelected) {
							if(row.hasOwnProperty(MANAGE_CONTACT_DETAILS_CONSTANTS.EMAILID)) {
								row.isVisible = true;
							}
						}
						if(nextProps.hrmw.appliedFilters.isFaxFilterSelected) {
							if(row.hasOwnProperty(MANAGE_CONTACT_DETAILS_CONSTANTS.FAX)) {
								row.isVisible = true;
							}
						}
						if(nextProps.hrmw.appliedFilters.isPhoneFilterSelected) {
							if(row.hasOwnProperty(MANAGE_CONTACT_DETAILS_CONSTANTS.PHONE)) {
								row.isVisible = true;
							}
						}
					}
				});
			} else 
			// only person ID selected
			if(nextProps.hrmw.appliedFilters.personIdSelected && !isContactTypeSelected)  {
				newContactArray.forEach(function (row) {
					row.isVisible = false;
					if(row.person.personId == nextProps.hrmw.appliedFilters.personIdSelected) {
						row.isVisible = true;
					}
				});
			} else {
				if(isContactTypeSelected) {
					// only contact type selected
					newContactArray.forEach(function (row) {
						row.isVisible = false;
						if(nextProps.hrmw.appliedFilters.isEmailFilterSelected) {
							if(row.hasOwnProperty(MANAGE_CONTACT_DETAILS_CONSTANTS.EMAILID)) {
								row.isVisible = true;
							}
						}
						if(nextProps.hrmw.appliedFilters.isFaxFilterSelected) {
							if(row.hasOwnProperty(MANAGE_CONTACT_DETAILS_CONSTANTS.FAX)) {
								row.isVisible = true;
							}
						}
						if(nextProps.hrmw.appliedFilters.isPhoneFilterSelected) {
							if(row.hasOwnProperty(MANAGE_CONTACT_DETAILS_CONSTANTS.PHONE)) {
								row.isVisible = true;
							}
						}
					});
				}
			}
		}

		// set newly added contact details
		if (!isEmpty(nextProps.hrmw.newContactDetails)) {

			// get newly added contact details
			let newContactDetails = nextProps.hrmw.newContactDetails;

			// get selected person details by personId
			let perticularPersonData = nextProps.hrmw.contactDetailsPersonData;
			perticularPersonData = perticularPersonData.filter((row) => row.personId == newContactDetails.personId);
			perticularPersonData = perticularPersonData[0];

			let personObj;
			if(perticularPersonData.name) {
				personObj = {
					name: perticularPersonData.name,
					firstName: '',
					middleName: '',
					lastName: ''
				};
			} else {
				personObj = {
					name: '',
					firstName: perticularPersonData.firstName,
					middleName: perticularPersonData.middleName,
					lastName: perticularPersonData.lastName
				};
			}
			personObj.personId = perticularPersonData.personId;
		
			// check and add email
			if (newContactDetails.emailId) {
				newContactArray.push({
					emailId: newContactDetails.emailId,
					person: personObj,
					contactId: Math.random(),
					isNewlyAdded: true,
					ealerts: PAPERLESS_OPT_IN_STATUS.EALERT_NO
				});
			}

			// check and add fax
			if (newContactDetails.fax) {
				let faxObj = {
					phoneNo: newContactDetails.fax,
					countryCode: newContactDetails.faxCountryCode
				};
				newContactArray.push({
					fax: faxObj,
					person: personObj,
					contactId: Math.random(),
					countryCode: newContactDetails.selectedFaxCountry,
					isNewlyAdded: true

				});
			}

			// check and add Phone No
			if (newContactDetails.phoneNo) {
				let phoneObj = {
					phoneNo: newContactDetails.phoneNo,
					phoneType: newContactDetails.phoneType,
					countryCode: newContactDetails.countryCode
				}
				newContactArray.push({
					phone: phoneObj,
					person: personObj,
					contactId: Math.random(),
					isNewlyAdded: true

				});
			}

		}

		// new contacts are added so deleting data from muster
		await this.props.hrmw.setNewContactDetails('');

		//set UI show data to muster
		await this.props.hrmw.setUpdatedContactDetails(newContactArray);

		// checking if there is any change in managecontactdetails array
		if(Array.isArray(newContactArray)) {
			newContactArray.forEach((row) => {
				if ((row.isNewlyAdded) || (row.isUpdated) || (row.isDeleted)|| (row.isEalert)|| 
				((nextProps.hrmw.contactDetailsStatus == 'DRAFT') && (row.action == ("DELETE"))) || 
				((nextProps.hrmw.contactDetailsStatus == 'DRAFT') && (row.action == ("UPDATE"))) || 
				((nextProps.hrmw.contactDetailsStatus == 'DRAFT') && (row.action == ("CREATE")))) {
					this.props.setAddedRow(row.isNewlyAdded);
					this.setState({ isDataUPdated: true });
				}
			});
		}


		this.setState({
			contactDetailsListData: newContactArray,
		});
	}

	saveContactDetailsOtp = async () => {
		await this.props.hrmw.contactDetailsOtp();
	}
	
	// Function to check if atleast one e-alert of type email should be enabled
	checkIfAtleastOneEalert = (dataToBeSend) => {
		const { i18n: { messages }, hrmw: { bpRoleData, bpIdSelected, fromPaperless }  } = this.props;
		let emailEAlertToggled = 0;
		// check if email Id parameter is present in the object or not
		const emailPresent = dataToBeSend.some(item => item.hasOwnProperty("emailId")); 
		const fliterBpRoleData = bpRoleData.find(bpRole => bpRole.bpId === bpIdSelected); 
		emailPresent && dataToBeSend.map((row) => {
			if(row.emailId && !(row.isDeleted || row.action === "DELETE")){
				if(row.ealerts === PAPERLESS_OPT_IN_STATUS.EALERT_YES){
					emailEAlertToggled = emailEAlertToggled + 1;
				}
			}
		})
		let paperlessFlag = fliterBpRoleData.paperlessOptinStatus === PAPERLESS_OPT_IN_STATUS.NO;
		if(emailEAlertToggled < 1 && fromPaperless){
			emailEAlertToggled = 0;
			paperlessFlag = false
		}
		if(fliterBpRoleData.paperlessOptinStatus === PAPERLESS_OPT_IN_STATUS.YES) {
			this.props.hrmw.setfromPaperless(false);
		}

		var message = emailPresent ? ((emailEAlertToggled > 0 || paperlessFlag) ? null : messages['app.profile.paperless.email.registered.msg']) : messages['app.profile.paperless.noEmail.registered.msg'];
		return message;
	}

	saveContactDetails = async() => {

		// WMCE-16276 - E-Alerts getting enabled for email which are in deletion state when 1FA OTP screen displays
		let dataToBeSend = JSON.parse(JSON.stringify(this.state.contactDetailsListData));
		
		const checkIfAtleastOneEalert = await this.checkIfAtleastOneEalert(dataToBeSend);

		if(checkIfAtleastOneEalert){
			alert(checkIfAtleastOneEalert);
		}else{
		dataToBeSend.forEach(function (row) {

			// contact UPdated or if E-alert toggle is true
			if (row.isUpdated || row.isEalert) {
				// updating action
				if (row.action == MANAGE_CONTACT_DETAILS_CONSTANTS.CREATE) {
					row.action = MANAGE_CONTACT_DETAILS_CONSTANTS.CREATE_UPDATE;
				}
				if (row.action == MANAGE_CONTACT_DETAILS_CONSTANTS.UPDATE) {
					row.action = MANAGE_CONTACT_DETAILS_CONSTANTS.UPDATE;
				}
				if (row.action == MANAGE_CONTACT_DETAILS_CONSTANTS.DELETE) {
					row.action = '';
				}
				if (row.action == MANAGE_CONTACT_DETAILS_CONSTANTS.READ) {
					row.action = MANAGE_CONTACT_DETAILS_CONSTANTS.UPDATE;
				}
			}

			// user has performed no action
			if(row.isUpdated == false && row.isDeleted == false && row.isNewlyAdded == false && row.isEalert == false) {
				if (row.action == MANAGE_CONTACT_DETAILS_CONSTANTS.CREATE) {
					row.action = MANAGE_CONTACT_DETAILS_CONSTANTS.CREATE_READ;
				}
				if (row.action == MANAGE_CONTACT_DETAILS_CONSTANTS.UPDATE) {
					row.action = MANAGE_CONTACT_DETAILS_CONSTANTS.UPDATE_READ;
				}
				if (row.action == MANAGE_CONTACT_DETAILS_CONSTANTS.DELETE) {
					row.action = MANAGE_CONTACT_DETAILS_CONSTANTS.DELETE_READ;
				}
				if (row.action == MANAGE_CONTACT_DETAILS_CONSTANTS.READ) {
					row.action = MANAGE_CONTACT_DETAILS_CONSTANTS.READ;
				}
			}

			// contact newly added
			if (row.isNewlyAdded) {
				row.action = MANAGE_CONTACT_DETAILS_CONSTANTS.CREATE;
			}

			// contact deleted
			if (row.isDeleted) {
				
				// updating action
				if (row.action == MANAGE_CONTACT_DETAILS_CONSTANTS.CREATE) {
					row.action = MANAGE_CONTACT_DETAILS_CONSTANTS.CREATE_DELETE;
				}
				if (row.action == MANAGE_CONTACT_DETAILS_CONSTANTS.UPDATE) {
					row.action = MANAGE_CONTACT_DETAILS_CONSTANTS.UPDATE_DELETE;
				}
				if (row.action == MANAGE_CONTACT_DETAILS_CONSTANTS.DELETE) {
					row.action = '';
				}
				if (row.action == MANAGE_CONTACT_DETAILS_CONSTANTS.READ) {
					row.action = MANAGE_CONTACT_DETAILS_CONSTANTS.DELETE;
				}
			}
		});

		let finalContactList = [];
		dataToBeSend.forEach(function (row) {
			let finalContactRow = {};
			if (row.emailId) {
				finalContactRow.emailId = row.emailId;
			}
			if (row.fax) {
				finalContactRow.fax = row.fax;
			}
			if(row.phone) {
				finalContactRow.phone = row.phone;
			}
			finalContactRow.person = { personId: row.person.personId };
			finalContactRow.action = row.action;
			finalContactRow.ealerts = row.ealerts;

			finalContactList.push(finalContactRow);
		});
		
		await this.props.hrmw.saveContactDetails(finalContactList);
	  }
	}

	amendContactDetail = async (row) => {
		if (row.action !== 'DELETE' && !row.isDeleted) {
			await this.props.hrmw.contactToBeAmend(row);
			this.props.changePage(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS_AMEND_CONTACT);
		}
	}

	// show Contact deletion confirmation modal
	showDeleteContactModal = async (index, row) => {

		if (row.action != 'DELETE' && !row.isDeleted ) {
			const { i18n: { messages } } = this.props;

			this.setState({
				showDeleterModal: true,
				contactToBeDeleted: row,
				selectedContactId: row.contactId,
				deleteContactTitle: `${messages['app.manageContactDetails.deleteContact.alertTitle']}`
			});
		}
	}

	deleteContactRow = () => {

		this.setState({
			selectedContactId: '',
			contactToBeDeleted: '',
			showDeleterModal: false
		});

	}

	hideFilterModal = () => {
		const { i18n: { messages }, hrmw: { appliedFilters } } = this.props;
		this.setState({
			showFilterModal: false,
		});
	}

	showFilterModal = () => {
		const { i18n: { messages }, hrmw: { filterCount } } = this.props;
		this.setState({
			showFilterModal: true,
			filterTitle: `${messages['app.manageContactDetails.filters']} (${filterCount})`
		});
	}

	deleteContactModalContent = () => {
		return <DeleteContactModal selectedContact={this.state.contactToBeDeleted} deleteContactRow={this.deleteContactRow} />
	}

	hideDeleteModal = async () => {
		this.setState({
			showDeleterModal: false
		});
	}

	addContactDetail = () => {
		this.props.changePage(ROUTES.PROFILE.ADD_CONTACT_DETAILS_ROUTE);
	}

	setFilterCount = (filterCount) => {
		const { i18n: { messages } } = this.props;
		this.setState({
			filterCount: filterCount,
			filterTitle: `${messages['app.manageContactDetails.filters']} (${filterCount})`
		});
	}

	filterModalContent = () => {
		return <FilterModal setFilterCount={(filterCount) => this.setFilterCount(filterCount)} closeFilterModal={this.closeFilterModal}/>
	}

	closeFilterModal = () => {
		this.setState({
			showFilterModal: false
		});
	}

	// Function called on E-alert toggle
	onEalertToggle = (item) => {
		this.props.hrmw.setToggledContactDetail(item);
		this.setState({
			isDataUPdated: false
		});
	}

	render() {
		const { i18n: { messages }, hrmw: { showSpinner, isManageContactDetailsMcd, isValidData, bpIdSelected, contactDetailsStatus, setDataUpdate, filterCount },
			paperless: { isEdocumentFlow } } = this.props;
		const { contactDetailsListData, isDataUPdated } = this.state;
		setDataUpdate(this.state.isDataUPdated);
		if (showSpinner) {
			return <LoadingCircle />
		}

		if(!isValidData) {
			return alert(messages['app.manageContactDetails.error.tryagain']);
		}

		if (isManageContactDetailsMcd) {
			return <VascoModal />
		}

		return (
			<div className="small-12 medium-12 large-12 large-centered">
				<div className="row headerMargin">
					<span className="pageHeader">{isEdocumentFlow ? messages['app.profile.paperless.title'] : messages['app.common.pageTitle.manageContactDetails']}</span>
					<Button className="filterButton" onClick={this.showFilterModal}>
						<Settings color={PALETTE.secondaryActive} />{messages['app.manageContactDetails.filters']} ({ filterCount })
					</Button>
				</div>

				<div style={{ backgroundColor: "#12223C", padding: '3%' }}>
					<div className="columns small-12 medium-12 large-12">
						{isEdocumentFlow && <h3>{messages['app.profile.paperless.enable.ealert']}</h3>}
						<h3>{messages['app.manageContactDetails.contactDetailsFor']} {bpIdSelected}</h3>
						<div className="column small-12 medium-12 large-12" style={{ padding: '10px' }}>
							<div className="columns large-3 medium-3 small-12">
								<Label>{messages['app.manageContactDetails.contacts']}</Label>
							</div>
							<div className="columns large-3 medium-3 small-12">
								<Label>{messages['app.manageContactDetails.type']}</Label>
							</div>
							<div className="columns large-3 medium-3small-12 rightTextAligned">
								<Label>{messages['app.manageContactDetails.person']}</Label>
							</div>
							<div className="columns large-1 medium-1 small-12">

							</div>
							<div className="columns large-1 medium-1 small-12">

							</div>
							<div className="columns large-1 medium-1 small-12 centerAligned">
								<Label>{messages['app.manageContactDetails.eAlert']}</Label>
							</div>
						</div>
					</div>

					{Array.isArray(contactDetailsListData) ? contactDetailsListData.map((item, index) => (
						<NavigationList fullWidth className="small-12 medium-12 large-12">
							<NavigationListItem hasArrow={false} disabled={item.action === "DELETE" || item.isDeleted} className={"column small-12 medium-12 large-12 " + (item.action === "DELETE" || item.isDeleted ? "disableRow" : "") + (item.isVisible == false ? " hideContent" : "")}>
								<div className="column small-12 medium-12 large-12 manage-container">

									<div className="columns large-3 medium-3 small-12">
										<span className={item.isDeleted || item.action === "DELETE" ? 'label label--inverse label--medium' : ''}>
											{item.emailId ? '' : (item.fax ? '+' + item.fax.countryCode : '+' + item.phone.countryCode) || "NA"}
										</span> &nbsp;
										<span className={item.isDeleted || item.action === "DELETE" ? 'label label--inverse label--medium' : ''}>
											{item.emailId ? item.emailId : (item.fax ? item.fax.phoneNo : item.phone.phoneNo) || "NA"}
										</span>
									</div>
									<div className="columns large-3 medium-3 small-12">
										<span className={item.isDeleted || item.action === "DELETE" ? 'label label--inverse label--medium' : ''}>
											{item.emailId ? messages['app.manageContactDetails.filter.email'] : (item.fax ? messages['app.manageContactDetails.addContact.fax'] 
											: (item.phone && ( item.phone.phoneType == "MOBILE" ? messages['app.manageContactDetails.filter.mobile'] : messages['app.manageContactDetails.filter.phone'])))}
										</span>
									</div>
									<div className="columns large-3 medium-3 small-12 rightTextAligned">
										<span className={item.isDeleted || item.action === "DELETE" ? 'label label--inverse label--medium' : ''}>
											{item.person.name ? item.person.name : `${item.person.firstName} ${item.person.lastName}`}
										</span>
										{item.action === "DELETE" || item.isDeleted ?
											<div className="rightTextAligned">
												<Label>{messages['app.manageContactDetails.deletionpending']}</Label>
											</div> : ''
										}
										{item.isUpdated || item.action == "UPDATE" && contactDetailsStatus === 'DRAFT'?
											<div className="rightTextAligned">
												<Label>{messages['app.manageContactDetails.updationpending']}</Label>
											</div> : ''
										}
										{item.isNewlyAdded || item.action == "CREATE" && contactDetailsStatus === 'DRAFT'?
											<div className="rightTextAligned">
												<Label>{messages['app.manageContactDetails.additionpending']}</Label>
											</div> : ''
										}

									</div>
									<div className="columns large-1 medium-1 small-12 rightLeftBordered centerAligned">
										<FormGroup>
											<div onClick={() => this.amendContactDetail(item)}><Edit color={PALETTE.loginFooterText} /></div>
											<Label>{messages['app.manageContactDetails.amend']}</Label>
										</FormGroup>
									</div>
									<div className="columns large-1 medium-1 small-12 rightLeftBordered centerAligned">
										<FormGroup>
											<div onClick={() => this.showDeleteContactModal(index, item)}><Trash color={PALETTE.loginFooterText} /></div>
											<Label>{messages['app.manageContactDetails.delete']}</Label>
										</FormGroup>
									</div>
									<div className="columns large-1 medium-1 small-12 manage-center-detail">
									<div className="eAlertpaperless">
										<div> 
											<Toggle
											    disabled={!item.emailId || item.action === "DELETE" || item.isDeleted } 
												checked={item.ealerts === PAPERLESS_OPT_IN_STATUS.EALERT_YES ? true : false}
												onChange={() => this.onEalertToggle(item)}
											/>
										</div>
										{item.fax || item.phone ?
										<div className="margin-left-10 iconrequest">
            <Popover
              mode="popup"
              orientation="top"
              showOnHover
              testID={`popover_manage_contact_details_model_test`}
              accessibilityLabel={`popover_manage_contact_details_model_test`}
              popOverClassName="manage-contact-details-content"
              content={
                <div testID={`popover_manage_contact_details_model_test`} accessibilityLabel={`popover_manage_contact_details_model_test`}>
                  {messages['app.profile.manageContactDetails.ealert']}
                </div>
              }
            >
              <Info2 color={PALETTE.secondaryText} />
            </Popover>
        </div>: ''}
		  </div>
									</div>
								</div>

							</NavigationListItem>
						</NavigationList>
					)) : <div className="columns small-12 medium-12 large-12 noData">
							{messages['app.manageContactDetails.noData']}
						</div>}
						<div className=" row small-12 medium-12 large-12 padding-top-50 customLogoDisplay">
							<div className="large-2 medium-2 small-12 padding-right-10">
								<Button fullWidth size='normal' onClick={this.addContactDetail}>
									{messages['app.manageContactDetails.addContactDetailsButton']}
								</Button>
							</div>
							<div className="large-2 medium-2 small-12">
								<Button fullWidth size='normal' onClick={this.saveContactDetails} disabled={(!Array.isArray(contactDetailsListData)) || (!isDataUPdated) }>
									{messages['app.manageContactDetails.finalSubmitButton']}
								</Button>
							</div>
						</div>
				</div>
				<BlurModal
					{...this.props}
					visible={this.state.showFilterModal}
					onDone={this.hideFilterModal}
					title={this.state.filterTitle}
					size="large"
				>
					{this.filterModalContent()}
				</BlurModal>
				<BlurModal
					visible={this.state.showDeleterModal}
					onDone={this.hideDeleteModal}
					title={this.state.deleteContactTitle}
					size="large"
				>
					{this.deleteContactModalContent()}
				</BlurModal>
			</div>
		)
	}
}
export default createContainer({
	$queries: {
		i18n: {
			messages: true,
		},
		hrmw: {
			saveFilters: { $call: 'saveFilters' },
			dataToBeSend: { $call: 'dataToBeSend' },
			contactDetailsOtp: { $call: 'contactDetailsOtp' },
			contactToBeAmend: { $call: 'setAmendContactDetail' },
			setDeletedContactList: { $call: 'setDeletedContactList' },
			saveContactDetails: { $call: 'saveContactDetails' },
			setNewContactDetails: { $call: 'setNewContactDetails' },
			setUpdatedContactDetails: { $call: 'setUpdatedContactDetails' },
			getContactDetailsListData: { $call: 'getContactDetailsListData' },
			setfromPaperless: { $call: 'setfromPaperless' },
			getBpData: {$call: 'getBpData'},
			bpRoleData: true,
			fromPaperless: true,
			bpIdSelected: true,
			filterCount: true,
			isValidData: true,
			showSpinner: true,
			deletedContact: true,
			appliedFilters: true,
			newContactDetails: true,
			amendContactDetail: true,
			actualDataToBeSend: true,
			latestContactDetails: true,
			isManageContactDetails: true,
			contactDetailsListData: true,
			contactDetailsPersonData: true,
			saveContactDetailsStatus: true,
			otpVerified: true,
			isManageContactDetailsMcd: true,
			contactDetailsStatus: true,
			setDataUpdate: { $call: 'setDataUpdate' },
			toggledContactDetail: true,
			setToggledContactDetail: { $set: 'toggledContactDetail' },
			setIsMCDPage: { $set: 'isMCDPage' },
			setIsAddContactDetailsFlow: { $set: 'isAddContactDetailsFlow' },
		},
		setManageContactDetails: { $set: 'hrmw.isManageContactDetails' },
		setDeletedRow: { $set: 'hrmw.isRowDeleted' },
		setAddedRow: { $set: 'hrmw.isRowAdded' },
		paperless: {
			isEdocumentFlow: true,
		},
	},
})(ManageContactDetails);